import { useState as e } from "react";
const O = 0;
function x(s, r, u, o, t, h) {
  const [c, f] = e(!1), a = c ? u : o, [g, C] = e(a ? a.length : O), [B, n] = e(!1);
  return {
    valueCounter: g,
    isOnBlur: B,
    hasLabelOrHelperText: !!(s ?? r),
    handleBlur: () => {
      n(!0), h?.();
    },
    handleChange: (l) => {
      f(!0), C(l.target.value.length), t && t(l), n(!1);
    }
  };
}
export {
  x as useTextarea
};
